import { useQuery } from '@tanstack/react-query';

import { fetchEscritorios } from '@/api/client';
import { fetchAcessiveis } from '@/api/secretario';
import { queryKeys } from '@/lib/pwa/queryConfig';

/** "Só meu" — o Secretário pessoal; senão, o id do escritório. */
export const SO_MEU = 'pessoal';

/**
 * De quem é o Secretário que está sendo criado (docs/PLANO_SECRETARIO_ESCRITORIO.md §4.1):
 * o pessoal ("só meu") ou o de um escritório em que o usuário é o Proprietário e que
 * ainda não tem um. Com um escritório só e sem o pessoal, o escritório vem marcado —
 * o escritório solo (§2 D4).
 */
export function useEscoposDisponiveis(criando: boolean) {
  const acessiveis = useQuery({
    queryKey: queryKeys.secretario.acessiveis,
    queryFn: fetchAcessiveis,
    enabled: criando,
  });
  const escritorios = useQuery({ queryKey: queryKeys.escritorios.all, queryFn: fetchEscritorios, enabled: criando });
  const jaTem = acessiveis.data ?? [];
  const pessoal = !jaTem.some((c) => c.escopo === 'PESSOAL');
  const doEscritorio = (escritorios.data ?? []).filter(
    (e) => e.meu_role === 'PROPRIETARIO' && !jaTem.some((c) => c.escopo === 'ESCRITORIO' && c.escritorio_id === e.id),
  );
  return { pessoal, doEscritorio, carregando: acessiveis.isLoading || escritorios.isLoading };
}
